import component from "frontend/legacy/unavailable-alert"

export default component
